import { COLORS } from '../styles/Constants';
import { Comment } from './Comment';
import { Session } from './Session';
import { User } from './User';

export type Bug = {
  priority: 'HIGH' | 'MEDIUM' | 'LOW';
  processingUser?: User;
  mentions?: string[];
  status: string;
  hideDetailTabsOnSharedBugs?: boolean;
  dueDate?: Date;
  hideContent?: boolean;
  createdAt: any;
  updatedAt: any;
  type: string;
  isSpam: boolean;
  title: string;
  content: any;
  description: string;
  session?: Session;
  reportedBy: string;
  latestComment?: Comment;
  reportedByName?: string;
  screenshotBroke?: Date;
  id: string;
  lexorank: string;
  shareToken: string;
  secretShareToken?: string;
  bugId: number;
  metaData: any;
  screenshotUrl: string;
  consoleLog: [];
  actionLog: [];
  attachments: [
    {
      name: string;
      url: string;
      type: string;
    },
  ];
  customData: {};
  generatingScreenshot?: Boolean;
  screenshotLive?: Boolean;
  screenRecordingUrl?: string;
  formData?: any;
  form?: any;
  upvotesCount?: number;
  upvotes?: [
    {
      email: string;
    },
  ];
  pagerating?: number;
  replay?: {
    frames: {
      url: string;
      date: Date;
      screenname: string;
    }[];
    interval: number;
  };
  replayDataUrl?: string;
  hasWebReplay: boolean;
  project: any;
  plan: any;
  notificationsUnread?: Boolean;
  snoozedUntil?: Date;
  lastNotification?: Date;
  duplicateOf?: string;
  duplicatesCount?: number;
  archived?: Boolean;
  tags?: string[];
  integrations?: any;
  plainContent?: string;
};

export const BugPriorities = {
  LOW: {
    title: 'Low',
    value: 'LOW',
    color: COLORS.BUGBATTLE_GREEN,
  },
  MEDIUM: {
    title: 'Medium',
    value: 'MEDIUM',
    color: COLORS.BUGBATTLE_ORANGE,
  },
  HIGH: {
    title: 'High',
    value: 'HIGH',
    color: COLORS.BUGBATTLE_RED,
  },
};
